import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { OperatingSystemService } from 'ui-components/services/operating-system-service';

import Global from '../../../store/global-selectors';

export const useSellerPresetHotkeys = (ctrlOrCmd) => {
  const presets = useSelector(Global.selectSellerPresets);
  const presetHotkeys = useMemo(() => {
    return presets.reduce((acc, preset) => {
      const { hotKey, name } = preset;
      if (hotKey) {
        const letterUppercase = hotKey.toUpperCase();
        acc.push({
          hotkey: `${ctrlOrCmd} + ${letterUppercase}`,
          name,
        });
      }
      return acc;
    }, []);
  }, [ctrlOrCmd, presets]);
  return presetHotkeys;
};

export const useCtrlOrCmd = () => (OperatingSystemService.isMac() ? 'Cmd' : 'Ctrl');
